const StoreGetter = Object.freeze({
  sysMenu: "SysMenuStore/sysMenu",
  lang: "AuthenticationStore/lang",
  token: "AuthenticationStore/token",
  user: "AuthenticationStore/user",
  isRememberMe: "AuthenticationStore/isRememberMe",
  rememberedUsername: "AuthenticationStore/rememberedUsername",
  rememberedPassword: "AuthenticationStore/rememberedPassword",
  sysMsg: "SysMsgStore/sysMsg",
  unsave: "UnsaveStore/unsave",
  serverRouter: "ServerRouterStore/serverRouter",
  sysParams: "SysParamsStore/sysParams",
  candidateInvited: "IntAssessHdrStore/candidateInvited",
  candidatelLang: "AuthenticationStore/setCandidatelLang"
});

export default StoreGetter;



// WEBPACK FOOTER //
// ./src/constants/StoreGetter.js